import { IComponentOptions } from 'angular';
import template from './pie-chart-settings.html';
import controller from './pie-chart-settings.controller';

import './pie-chart-settings.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
